import React, { Fragment, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProfileById } from "../../actions/profile";
import { getPurchases } from "../../actions/purchase";

import GreenLogo from "../layout/Innovators/GreenLogo";
import IMEAltLogo from "../layout/IME/IMEAltLogo";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import PurchaseItem from "../layout/IME/PurchaseItem";

import GreenSpinner from "../../img/Green_Spinner.gif";
import RedSpinner from "../../img/Red_Spinner.gif";
import BlueSpinner from "../../img/Blue_Spinner.gif";

const Purchases = ({
  match,
  auth: { user },
  profile: { profile },
  isAuthenticated,
  getProfileById,
  getPurchases,
  purchase: { purchases, loading },
}) => {
  useEffect(() => {
    getProfileById(match.params.channelid);
    getPurchases();
  }, [getProfileById, getPurchases]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user.channelid !== match.params.channelid) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <div className="action-items-index">
          <Link to="/">
            <div
              className={`action-button-index ${
                user && user.role === "innovator"
                  ? "green"
                  : user && user.role === "mentor"
                  ? "red"
                  : user && user.role === "employer"
                  ? "blue"
                  : ""
              }`}
            >
              <i
                className={`fas fa-angle-left action-icon-index-alt fa-lg ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
            </div>
          </Link>
          <p
            className={`action-text-index ${
              user && user.role === "innovator"
                ? "green"
                : user && user.role === "mentor"
                ? "red"
                : user && user.role === "employer"
                ? "blue"
                : ""
            }`}
          >
            Back
          </p>
        </div>
        <Link to="/">
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark green fa-sm mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </Link>
      </nav>
      <div>
        {/* <LoggedInNav /> */}
        <div className="flex-all-content-fixed">
          <section className="banner-hero-alt">
            <div className="banner-section-name">
              <h1
                className={`large-font ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Purchases
              </h1>
            </div>
          </section>
          {loading ? (
            <div className="profile-error">
              <img src={GreenSpinner} alt="green-spinner" />
            </div>
          ) : (
            <section className="main-body">
              <div className="purchase-container">
                {purchases && purchases.length <= 0 && (
                  <p
                    className={`empty-content-alt ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    No Purchases
                  </p>
                )}
                {purchases &&
                  purchases.length > 0 &&
                  purchases.map((purchase) => {
                    return (
                      <PurchaseItem purchase={purchase} key={purchase._id} />
                    );
                  })}
              </div>
            </section>
          )}
        </div>
      </div>
      {/* {profile && profile.role === "mentor" && profile.id === user.id && (
        <div>
          <LoggedInNavRed />
          <div className="flex-all-content-fixed">
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Purchases</h1>
              </div>
            </section>
            {loading ? (
              <div className="profile-error">
                <img src={RedSpinner} alt="red-spinner" />
              </div>
            ) : (
              <section className="main-body">
                <div className="purchase-container">
                  {purchases && purchases.length <= 0 && (
                    <p className="empty-content-alt red">No Purchases</p>
                  )}
                  {purchases &&
                    purchases.length > 0 &&
                    purchases.map((purchase) => {
                      return (
                        <PurchaseItem purchase={purchase} key={purchase._id} />
                      );
                    })}
                </div>
              </section>
            )}
          </div>
        </div>
      )}
      {profile && profile.role === "employer" && profile.id === user.id && (
        <div>
          <LoggedInNavBlue />
          <div className="flex-all-content-fixed">
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Purchases</h1>
              </div>
            </section>
            {loading ? (
              <div className="profile-error">
                <img src={BlueSpinner} alt="blue-spinner" />
              </div>
            ) : (
              <section className="main-body">
                <div className="purchase-container">
                  {purchases && purchases.length <= 0 && (
                    <p className="empty-content-alt blue">No Purchases</p>
                  )}
                  {purchases &&
                    purchases.length > 0 &&
                    purchases.map((purchase) => {
                      return (
                        <PurchaseItem purchase={purchase} key={purchase._id} />
                      );
                    })}
                </div>
              </section>
            )}
          </div>
        </div>
      )} */}
    </Fragment>
  );
};

Purchases.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  getPurchases: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  purchase: state.purchase,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { getProfileById, getPurchases })(
  Purchases
);
